export const smartHomeId = {
  description: 'smart-home-description',
  section: 'smart-home-section',
  title: 'smart-home-title',
};
